import {useEffect, useMemo, useState} from "react";
import GraphicUtils from "../../../../../../utils/graphic-utils.js";
import EditorButton from "../../../../../../components/reports/editor-report/editor-button.jsx";
import EditorInput from "../../../../../../components/reports/editor-report/editor-input.jsx";

export default function IndividualAge({ profileData, data, setMode }) {
    const [callEditor, setCallEditor] = useState(false);

    const ageData = useMemo(() => {
        const source = Array.isArray(data?.individualAge)
            ? data.individualAge.filter(item => item?.classif === profileData?.profile)
            : [];

        return {
            labels: source.map(item => item?.age_range),
            values: source.map(item => Number(item?.qty || 0)),
        };
    }, [data, profileData]);

    useEffect(() => {
        GraphicUtils.barChart(
            chartId,
            ageData.values,
            ageData.labels,
        );
    }, [ageData]);

    const chartId = `individual-age-${profileData?.profile?.toLowerCase()?.replace(/\s+/g, "-")}`;

    return (
        <>
            <div className="chart-report">
                <div className="flex flex-row gap-2">
                    <span className="chart-title">Idade dos indivíduos</span>
                    <EditorButton callEditor={callEditor} setCallEditor={setCallEditor}/>
                </div>

                <div className="mt-3" id={chartId}/>
            </div>

            <EditorInput callEditor={callEditor} setMode={setMode}/>
            <div className="chart-divisor"/>
        </>
    )
}